import { FusionError, safeParseJson, serializeFusionError } from '@fusion-advantage/backcompat'
import { AxiosResponse } from "axios"
import { err, ok, Result } from "neverthrow"
import z from "zod"

// XFrontendMw.go
export interface XFrontend {
	Platform: string|null
	JsBundle: number|null
	MobileBuild: number|null
}

export const ZXFrontendRequired = z.object({
	MinJsBundle: z.number(),
	UpdateJsBundle: z.boolean(),
	UpdateJsBundleImmediate: z.boolean(),
	MinMobileBuild: z.number(),
	UpdateMobileBuild: z.boolean(),
})

export type XFrontendRequired = z.infer<typeof ZXFrontendRequired>

export const getFrontendRequired = (response: AxiosResponse): Result<null|XFrontendRequired, FusionError> => {
	if(!response.headers["x-frontend-required"]) {
		return ok(null)
	}
	const r = safeParseJson(response.headers["x-frontend-required"], ZXFrontendRequired)
	if(r.isErr()) {
		return err(serializeFusionError('getFrontendRequired', r.error))
	}
	if(r.value.UpdateJsBundle || r.value.UpdateMobileBuild) {
		return ok(r.value)
	}
	return ok(null)
}

export enum EnvName {
	Prod = "PRODUCTION",
	Dev = "DEVELOPMENT",
	Uat = "UAT"
}

// export interface JsBundle {
// 	Id: string
// 	Timestamp: number
// 	MinMobileBuild: number
// 	MaxMobileBuild: number
// 	Environments: EnvName[]
// }
